export default __webpack_public_path__ + "static/home-geo1-4895839eb332327c801e5c71956d82d8.gif";